<template>
  <div>
    <five-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj="titleObj"
    >
    </five-header>
    <five-center></five-center>
    <five-footer
      :bottomNews="bottomNews"
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :productType="productType"
    >
    </five-footer>
  </div>
</template>
<script>
import FiveHeader from "@/components/pc/Header";
import FiveCenter from "@/components/pc/FiveCenter";
import FiveFooter from "@/components/pc/Footer";
export default {
  name: "fiveG",
  data() {
    return {
      topStyle: "",
      actIndex: 2,
      imgList: [],
      logo: "",
      productType: [],
      bottom: {},
      bottomInfo: {},
      bottomNews: [],
      background: require("../../static/images/fiveG/bg.png"),
      titleObj: {},
    };
  },
  components: {
    FiveHeader,
    FiveCenter,
    FiveFooter,
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.titleObj = {
      title: "5G彩信",
      desc: "实时互动，双向链接，企业与客户的联络者\n链起您与用户的沟通桥梁，做就做说一不二的精准营销",
    };
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_fiveG");
      } else {
        this.$router.push("/five_g");
      }
    },
    getPageData() {
      this.$http.post("home/index/product", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        this.topStyle = "background-image:url('" + this.background + "')";
        this.bottomInfo = res.data.contact[0];
        this.productType = res.data.type;
        this.productAll = res.data.product;
        this.bottomNews = res.data.b_news;
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/pc/fiveG.vue